import axios from "axios";
import { EDITION_ID, EDITION, isRegion } from "@/lib/edition";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ga_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (isRegion) {
    config.headers["X-Edition"] = EDITION_ID;
    const sc = EDITION.scope || {};
    if (sc.country) config.headers["X-Edition-Country"] = sc.country;
    if (sc.state) config.headers["X-Edition-State"] = sc.state;
    if (sc.region) config.headers["X-Edition-Region"] = sc.region;
  }
  return config;
});

export function fileUrl(fileId) {
  if (!fileId) return null;
  return `${API}/files/${fileId}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
